import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess101002ParamStatus: 'idle',
    startProcess101002ParamError: undefined as any,
    loadUserParamsProcess101002ParamStatus: 'idle',
    loadUserParamsProcess101002ParamError: undefined as any,

    process101002ParamList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess101002Param = createAsyncThunk('process101002ParamSlice/startProcess101002Param', async ({ process101002Param }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess101002Param/`,
        prepareData(process101002Param),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess101002ParamStatus } = getState().process101002ParamSlice
        return startProcess101002ParamStatus !== 'pending'
    }
})

export const loadUserParamsProcess101002Param = createAsyncThunk('process101002ParamSlice/loadUserParamsProcess101002Param', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess101002Param/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess101002ParamStatus } = getState().process101002ParamSlice
        return loadUserParamsProcess101002ParamStatus !== 'pending'
    }
})

const Process101002ParamSlice = createSlice({
    name: 'process101002ParamSlice',
    initialState,
    reducers: {
        resetstartProcess101002Param: (state) => {
            state.job = undefined
            state.startProcess101002ParamError = undefined
        },
        resetstartProcess101002ParamError: (state) => {
            state.startProcess101002ParamError = undefined
        },
        resetloadUserParamsProcess101002Param: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess101002ParamError = undefined
        },
        resetloadUserParamsProcess101002ParamError: (state) => {
            state.loadUserParamsProcess101002ParamError = undefined
        },
        removeFromProcess101002ParamListById: (state, action) => {
            state.process101002ParamList = state.process101002ParamList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess101002ParamListByIds: (state, action) => {
            state.process101002ParamList = state.process101002ParamList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process101002ParamList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess101002ParamStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process101002ParamList = []
            state.startProcess101002ParamStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess101002Param.pending, (state) => {
            state.startProcess101002ParamStatus = 'pending'
            state.startProcess101002ParamError = undefined
        })
        builder.addCase(startProcess101002Param.fulfilled, (state, action) => {
            state.startProcess101002ParamStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess101002Param.rejected, (state, action) => {
            state.startProcess101002ParamStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess101002ParamError = action.error.message
            } else {
                state.startProcess101002ParamError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess101002Param.pending, (state) => {
            state.loadUserParamsProcess101002ParamStatus = 'pending'
            state.loadUserParamsProcess101002ParamError = undefined
        })
        builder.addCase(loadUserParamsProcess101002Param.fulfilled, (state, action) => {
            state.loadUserParamsProcess101002ParamStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess101002Param.rejected, (state, action) => {
            state.loadUserParamsProcess101002ParamStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess101002ParamError = action.error.message
            } else {
                state.loadUserParamsProcess101002ParamError = action.payload
            }
        })

    }
})

export const {
    resetstartProcess101002Param,
    resetstartProcess101002ParamError,
    resetloadUserParamsProcess101002Param,
    resetloadUserParamsProcess101002ParamError,
    removeFromProcess101002ParamListById,
    removeFromProcess101002ParamListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process101002ParamSlice.actions
export default Process101002ParamSlice.reducer
